export const SET_CONTENTS_LIST = 'SET_CONTENTS_LIST';
export const SET_CONTENT_VALUE = 'SET_CONTENT_VALUE';
export const RESET_CONTENTS = 'RESET_CONTENTS';
export const ADD_CONTENT = 'ADD_CONTENT';
export const SET_CONTENT_VARIABLES_LIST = 'SET_CONTENT_VARIABLES_LIST';
export const SET_CONTENT_VARIABLE_VALUE = 'SET_CONTENT_VARIABLE_VALUE';
export const RESET_CONTENT_VARIABLES = 'RESET_CONTENT_VARIABLES';
export const ADD_CONTENT_VARIABLE = 'ADD_CONTENT_VARIABLE';
export const SET_STOCK_CLOSINGS_LIST = 'SET_STOCK_CLOSINGS_LIST';
export const SET_STOCK_CLOSING_VALUE = 'SET_STOCK_CLOSING_VALUE';
export const RESET_STOCK_CLOSINGS = 'RESET_STOCK_CLOSINGS';
export const ADD_STOCK_CLOSING = 'ADD_STOCK_CLOSING';
export const SET_SIEVE_OPENINGS_LIST = 'SET_SIEVE_OPENINGS_LIST';
export const SET_SIEVE_OPENING_VALUE = 'SET_SIEVE_OPENING_VALUE';
export const RESET_SIEVE_OPENINGS = 'RESET_SIEVE_OPENINGS';
export const ADD_SIEVE_OPENING = 'ADD_SIEVE_OPENING';
export const SET_MATERIAL_SPECIFICATIONS_LIST = 'SET_MATERIAL_SPECIFICATIONS_LIST';
export const SET_MATERIAL_SPECIFICATION_VALUE = 'SET_MATERIAL_SPECIFICATION_VALUE';
export const RESET_MATERIAL_SPECIFICATIONS = 'RESET_MATERIAL_SPECIFICATIONS';
export const ADD_MATERIAL_SPECIFICATION = 'ADD_MATERIAL_SPECIFICATION';

export const SET_UPPER_SIEVE_OPENINGS_LIST = 'SET_UPPER_SIEVE_OPENINGS_LIST';

export const SET_LOWER_SIEVE_OPENINGS_LIST = 'SET_LOWER_SIEVE_OPENINGS_LIST';

export const SET_CONTROL_SIEVES_LIST = 'SET_CONTROL_SIEVES_LIST';

export const SET_GRANULOMETRIES_LIST = 'SET_GRANULOMETRIES_LIST';
export const SET_GRANULOMETRY_VALUE = 'SET_GRANULOMETRY_VALUE';
export const RESET_GRANULOMETRIES = 'RESET_GRANULOMETRIES';
export const ADD_GRANULOMETRY = 'ADD_GRANULOMETRY';
